export default {
  'section-default': {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto section-default',
    componentWrapper: 'componentWrapper mx-auto discover-button',
  },
  GoldieBannerSection: {
    section: '',
    container: 'flex md: w-full lg:w-full mx-auto section-default GoldieBannerSection',
    componentWrapper: 'componentWrapper mx-auto',
  },
  JamieBannerSection: {
    section: 'w-full JamieBannerSection',
    container: 'block md:w-full lg:w-full mx-auto section-default JamieBannerContainer',
    componentWrapper: 'componentWrapper mx-auto',
  },
  JamieBannerSectionLink: {
    section: 'w-full JamieBannerSectionLink',
    container: 'block md:w-full lg:w-full mx-auto section-default JamieBannerContainer',
    componentWrapper: 'componentWrapper mx-auto',
  },
  'jamie-collection-section':{
    section: 'w-full JamieCollectionSection',
    container: 'block w-full mx-auto section-default JamieCollectionContainer',
    componentWrapper: 'componentWrapper mx-auto',
  },
  'Goldie-SC-three':{
    section: '',
    container: 'flex lg:w-innerContainer mx-auto SafetySectionTwo GoldieSCthree',
    componentWrapper: 'componentWrapper md:flex justify-between mx-auto mt-20 ',
  },
  'Goldie-down-arrow-icon':{
    section: '',
    container: 'flex lg:w-innerContainer mx-auto section-default Goldiedownarrowicon',
    componentWrapper: 'componentWrapper mx-auto',
  },
  'Goldie-down-arrow-icon-goldBg':{
    section: 'Goldie-down-arrow-icon-goldBg',
    container: 'flex lg:w-innerContainer mx-auto section-default Goldiedownarrowicon',
    componentWrapper: 'componentWrapper mx-auto',
  },
  'Goldie-perlas-pro-v-one':{
    section: '',
    container: 'flex lg:w-innerContainer mx-auto section-default Goldieperlasprovone',
    componentWrapper: 'componentWrapper mx-auto',
  },
  'Goldie-perlas-pro-v-one-gold':{
    section: 'Goldie-perlas-pro-v-one-gold',
    container: 'flex lg:w-innerContainer mx-auto section-default Goldieperlasprovone',
    componentWrapper: 'componentWrapper mx-auto',
  },
  "Goldie-perlas-pro-v-two":{
    section: '',
    container: 'flex lg:w-innerContainer mx-auto section-default Goldieperlasprovtwo',
    componentWrapper: 'componentWrapper mx-auto',
  },
  GoldieBannersecondSection: {
    section: '',
    container: 'flex md: w-full lg:w-full mx-auto section-default GoldieBannersecondSection',
    componentWrapper: 'componentWrapper mx-auto',
  },
  SafetySectionTwo: {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto SafetySectionTwo commonBannerEight',
    componentWrapper: 'componentWrapper md:flex justify-between mx-auto mt-20',
  },
  SafetyHeadingBannerSection: {
    section: '',
    container: 'lg:w-innerContainer mx-auto SafetyHeadingBannerSection',
    componentWrapper: 'componentWrapper mx-auto',
  },
  savewaterRichTextSection: {
    section: '',
    container: 'flex mt-14p md:mt-3p lg:w-innerContainer mx-auto',
    componentWrapper: 'componentWrapper mx-auto',
  },
  savewatervoicesabosection: {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto savewatervoicesabosectioncontainer w-80p md:w-56p md-mb-4p md:mt-2p',
    componentWrapper: ' md:flex componentWrapper mx-auto',
  },
  savewaterFourthCardSection: {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto savewaterFourthCardSection',
    componentWrapper: 'md:flex componentWrapper mx-auto   savewaterFourthCardSectioncontainer ',
  },
  savewaterFourthSection: {
    section: '',
    container: 'lg:w-innerContainer mx-auto',
    componentWrapper: '  componentWrapper mx-auto savewaterFourthSectionImagecontext',
  },
  savewaterSobreBannerSection: {
    section: '',
    container: ' lg:w-innerContainer mx-auto',
    componentWrapper: 'componentWrapper mx-auto',
  },
  savewaterBannerSection: {
    section: '',
    container: ' lg:w-innerContainer mx-auto',
    componentWrapper: 'componentWrapper mx-auto',
  },
  ManifestoCardSection: {
    section: '',
    container: 'lg:w-innerContainer mx-auto',
    componentWrapper: 'componentWrapper mx-auto',
  },
  ManifestosecondCardSection: {
    section: '',
    container: 'lg:w-innerContainer mx-auto',
    componentWrapper: 'componentWrapper mx-auto',
  },
  RecycleThirdSection: {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto RecycleThirdSection',
    componentWrapper: ' md:flex componentWrapper w-80p md:w-12/12 mx-auto mt:3p mb-1p md:mt-5p md:mb:7p RecycleThirdSectioncontainer',
  },
  Recyclefoursection: {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto Recyclefoursection',
    componentWrapper: ' md:flex componentWrapper mx-auto Recyclefoursectioncontainer',
  },
  RecycleBannerSection: {
    section: '',
    container: ' lg:w-innerContainer mx-auto relative',
    componentWrapper: 'componentWrapper mx-auto',
  },
  RecycleBanner: {
    section: '',
    container: 'lg:w-innerContainer mx-auto relative',
    componentWrapper: 'componentWrapper mx-auto',
  },

  RecycleRichTextSection: {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto relative',
    componentWrapper: 'componentWrapper mx-auto',
  },
  RecycleSCStackedSection: {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto RecycleSCStackedSection',
    componentWrapper: 'md:flex componentWrapper mx-auto',
  },
  SafetyQualityThirdSection: {
    section: '',
    container: 'lg:w-innerContainer mx-auto SafetyQualityThirdSection',
    componentWrapper: 'componentWrapper mx-auto',
  },
  SafetyTestedSection: {
    section: '',
    container: 'lg:w-innerContainer mx-auto SafetyTestedSection',
    componentWrapper: 'componentWrapper mx-auto',
  },
  SafetyFiveSection: {
    section: 'SafetyFiveSection md:block hidden',
    container: 'lg:w-innerContainer mx-auto',
    componentWrapper: 'componentWrapper mx-auto',
  },
  SafetyFiveSectionMobile: {
    section: 'SafetyFiveSectionMoblie block md:hidden',
    container: 'flex lg:w-innerContainer mx-auto',
    componentWrapper: 'componentWrapper mx-auto',
  },
  SafetySixthSection: {
    section: 'SafetySixthSection',
    container: 'flex lg:w-innerContainer mx-auto',
    componentWrapper: 'componentWrapper mx-auto md:flex md:my-20',
  },
  SafetySevethSection: {
    section: 'SafetySevethSection',
    container: 'lg:w-innerContainer mx-auto',
    componentWrapper: 'componentWrapper mx-auto',
  },
  NoNoListStyling: {
    section: '',
    container: 'lg:w-innerContainer mx-auto NoNoListStyling',
    componentWrapper: 'componentWrapper mx-auto',
  },
  IngredientsSection: {
    section: '',
    container: 'flex  mx-auto',
    componentWrapper: 'componentWrapper mx-auto md:flex commonBannerTwo',
  },
  'section-w-full': {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto section-w-full',
    componentWrapper: 'componentWrapper w-full',
  },
  'flex-wrap-section': {
    section: '',
    container: 'flex lg:w-container mx-auto flex-wrap-section',
    componentWrapper: 'componentWrapper flex flex-wrap lg:-mx-15 md:mx-15',
  },
  'flex-wrap-section-look': {
    section: '',
    container: 'flex lg:w-container mx-auto flex-wrap-section-look',
    componentWrapper:
      'componentWrapper flex flex-wrap lg:-mx-15 md:mx-15 look-button',
  },
  'section-flex-wrap-section-look': {
    section: '',
    container: 'text-center',
    componentWrapper:
      'componentWrapper flex flex-wrap lg:-mx-15 md:mx-15 look-button',
  },
  'section-p-80-100': {
    section: '',
    container: 'flex lg:w-container mx-auto section-p-80-100',
    componentWrapper:
      'componentWrapper mx-auto sm:pt-30 md:pt-80 sm:pb-80 md:pb-100',
  },
  'section-p-80-look': {
    section: '',
    container: 'flex lg:w-container mx-auto section-p-80-look',
    componentWrapper:
      'componentWrapper mx-auto sm:pt-30 md:pt-20 sm:pb-80 md:pb-80',
  },
  'defrizz-and-illuminate-section-2': {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto lg:pt-40 lg:pb-70',
    componentWrapper: 'componentWrapper',
  },
  'article-detail-section-container': {
    section: '',
    container: 'flex lg:w-articleContainer mx-auto discover-button',
    componentWrapper: 'componentWrapper w-full',
  },
  'article-detail-section-container-how-it-all': {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto article-detaile',
    componentWrapper: 'componentWrapper w-full',
  },
  'section-listing': {
    section: '',
    container: 'lg:w-container mx-auto md:pb-0',
    componentWrapper: 'componentWrapper',
  },
  'Nonosection-listing': {
    section: '',
    container: 'lg:w-container mx-auto Nonosection-listing',
    componentWrapper: 'componentWrapper',
  },
  'Nonosection-listing-2': {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto Nonosection-listing-2',
    componentWrapper: 'componentWrapper',
  },
  'ingredients-para-1': {
    section: 'section',
    container: '',
    componentWrapper:
      'text-18 md:text-16 leading-28 text-black font-HelveticaNeueLight tracking-normal pb-52 md:pb-40',
  },
  'ingredients-para-2': {
    section: 'mb-38 md:mb-30 inline-block mdp:block lg:block lg:float-left',
    container: 'section',
    componentWrapper: '',
  },
  'ingredients-para-3': {
    section: 'mb-18 md:mb-30 inline-block  lg:block lg:float-left',
    container: 'section',
    componentWrapper: '',
  },
  'ingredients-card-container': {
    section: 'section',
    container: '',
    componentWrapper: '',
  },
  'stands-for-cards-container': {
    section: '',
    container: '',
    componentWrapper: '',
  },
  'before-after-image-wrapper': {
    section: 'flex',
    container: 'w-full lg:w-container mx-auto px-35 md:px-15',
    componentWrapper: 'componentWrapper',
  },
  'shampoo-banner': {
    section: 'flex',
    container: '',
    componentWrapper: '',
  },
  'article-detail-section-container-purple': {
    section: 'flex',
    container: 'lg:w-container mx-auto',
    componentWrapper: 'componentWrapper',
  },
  'article-detail-section-container-brassy': {
    section: 'flex',
    container: 'lg:w-container mx-auto',
    componentWrapper: 'componentWrapper',
  },
  'collection-card': {
    section: 'section',
    container: '',
    componentWrapper: 'componentWrapper',
  },
   'collection-card-gold': {
    section: 'collection-card-gold',
    container: 'md:w-full lg:w-full',
    componentWrapper: 'componentWrapper',
  },
  'power-of-grey-section': {
    section: 'power-of-grey-section',
    container: 'flex lg:max-w-container mx-auto',
    componentWrapper:
      'flex items-end w-full pb-0 lg:pb-80 flex-col md:flex-row',
  },
  'meetkristin-top-section': {
    section: 'power-of-grey-section meetkristin-top-section',
    container: 'flex lg:w-full mx-auto',
    componentWrapper:
      'flex items-end w-full pb-40 lg:pb-80 flex-col md:flex-row',
  },
  'lets-go-grey-section': {
    section: 'lets-go-grey-section',
    container: 'flex lg:max-w-container mx-auto',
    componentWrapper: 'sm:pb-0 lg:pb-80 w-full',
  },
  'grey-and-glow-section': {
    section: 'grey-and-glow-section bg-greyLightGlow',
    container: 'flex lg:max-w-container mx-auto',
    componentWrapper: '',
  },
  'watch-now-section': {
    section: 'watch-now-section bg-greyLightGlow pb-30 md:pb-50',
    container: 'flex lg:w-innerContainer mx-auto relative',
    componentWrapper: 'w-full',
  },
  'watch-now-section-how-it-all': {
    section: 'watch-now-section pb-30 md:pb-50',
    container: 'flex lg:w-innerContainer mx-auto relative',
    componentWrapper: 'w-full',
  },
  'power-of-grey-section-one': {
    section: 'section',
    container: '',
    componentWrapper: 'componentWrapper',
  },
  'section-homepage': {
    section: '',
    container: 'flex lg:w-full mx-auto homepage-sections',
    componentWrapper: 'componentWrapper mx-auto w-full',
  },
  'section-homepage-last-section': {
    section: '',
    container: 'flex lg:w-full mx-auto homepage-last-section',
    componentWrapper: 'componentWrapper mx-auto w-full',
  },
  'section-homepage-banner': {
    section: '',
    container: 'flex lg:w-full mx-auto homepage-sections',
    componentWrapper: 'componentWrapper mx-auto w-full homepage-new-banner',
  },
  'section-homepage-carousel': {
    section: '',
    container:
      'lg:w-full mx-auto  home-carousel overflow-hidden bg-white md:pb-100 relative',
    componentWrapper: 'componentWrapper homeHalfStickyCarousel',
  },
  'hair-has-no-gender-section-1': {
    section: 'hair-has-no-gender-section-1',
    container: 'flex mx-auto',
    componentWrapper: 'componentWrapper w-full',
  },
  'hair-has-no-gender-section-2': {
    section: 'hair-has-no-gender-section-2',
    container: 'lg:max-w-container mx-auto px-30 lg:px-15 lg:mb-80',
    componentWrapper: 'componentWrapper w-full flex flex-col lg:flex-row ',
  },
  'hair-has-no-gender-section-3': {
    section: 'hair-has-no-gender-section-3',
    container:
      'flex lg:max-w-container mx-auto relative px-30 lg:px-15 mb-30 lg:mb-80',
    componentWrapper: 'componentWrapper w-full',
  },
  'hair-has-no-gender-section-4': {
    section: 'hair-has-no-gender-section-4',
    container: 'flex lg:max-w-container mx-auto px-30 lg:px-15 relative',
    componentWrapper: 'componentWrapper w-full',
  },
  'meetkristin-video-section': {
    section: 'hair-has-no-gender-section-3',
    container:
      'flex lg:max-w-container mx-auto relative sm:px-0 px-30 lg:px-15 mb-30 lg:mb-80',
    componentWrapper: 'componentWrapper w-full',
  },
  'hair-biology-section-1': {
    section: 'hair-biology-section-1',
    container: 'flex mx-auto',
    componentWrapper: 'componentWrapper w-full',
  },
  'hair-biology-section-2': {
    section: 'hair-biology-section-2',
    container: 'flex mx-auto',
    componentWrapper:
      'componentWrapper w-90p bg-white -mt-150 md:mt-0 lg:w-full flex lg:w-innerContainer mx-auto flex-col md:flex-row new-hair-biology-lifetime',
  },
  'hair-biology-section-3': {
    section: 'hair-biology-section-3',
    container: 'flex mx-auto',
    componentWrapper: 'componentWrapper w-full',
  },
  'hair-biology-section-4': {
    section: 'hair-biology-section-4',
    container: 'flex mx-auto',
    componentWrapper: 'componentWrapper w-full',
  },
  'hair-biology-section-5': {
    section: 'hair-biology-section-5',
    container: 'flex mx-auto',
    componentWrapper: 'componentWrapper w-full',
  },
  'hair-biology-section-6': {
    section: 'hair-biology-section-6',
    container: 'flex mx-auto',
    componentWrapper: 'componentWrapper w-full',
  },
  'hair-biology-section-7': {
    section: 'hair-biology-section-7',
    container: 'flex mx-auto',
    componentWrapper: 'componentWrapper flex w-full flex-col md:flex-row',
  },
  'hair-biology-section-8': {
    section: 'hair-biology-section-8',
    container: 'flex mx-auto',
    componentWrapper: 'componentWrapper flex w-full',
  },
  'home-page-card': {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto justify-center',
    componentWrapper: 'componentWrapper md:flex  sm:p-8 md:p-0',
  },
  'section-white-30': {
    section:
      'section-white-30-section section section-white section-gutter w-full bg-white',
    container:
      'section-white-30-container banner-container section-white-30 text-15 font-HelveticaNeueMedium',
    componentWrapper: 'section-white-30-wrapper flex flex-wrap section-row',
  },
  footerSection: {
    section: 'footerSection-section prodCatMenu pb-40 pt-20',
    container: 'footerSection-container container pb-30',
    componentWrapper:
      'footerSection-wrapper flex flex-wrap section-row md:-mx-15 prodCatList',
  },
  UnidasPelosCachosSection: {
    section: 'hair-has-no-gender-section-1 test',
    container: 'flex mx-auto',
    componentWrapper: 'componentWrapper w-full',
  },
  'unidas-section-listing': {
    section: '',
    container: 'lg:w-container mx-auto md:pb-0 md:mt-90 md:px-15',
    componentWrapper: 'componentWrapper',
  },
  'unidas-video-section': {
    section: '',
    container: 'flex lg:w-container mx-auto mt-30 mb-100',
    componentWrapper: 'componentWrapper mx-auto',
  },
  'um-cabelo-card-section': {
    section: '',
    container: 'flex md:max-w-campaignContainer mx-auto',
    componentWrapper:
      'componentWrapper flex mx-auto mb-70 md:mb-10 flex-wrap md:flex-nowrap md:-mx-15',
  },
  'um-cabelo-panene-diz-tudo-section-3': {
    section: '',
    container: 'flex md:max-w-container mx-auto md:px-15 w-full',
    componentWrapper: 'componentWrapper mx-auto w-full',
  },
  'um-cabelo-panene-diz-tudo-section4': {
    section: '',
    container: 'flex lg:w-container mx-auto md:px-15',
    componentWrapper:
      'componentWrapper mx-auto mb-40 md:mb-50 mt-60 md:mt-80 cabeloFinalImgBanner',
  },
  'cabelo-article-detail-section-container': {
    section: '',
    container: 'flex md:w-articleContainer mx-auto cachosRichTxtMainContainer',
    componentWrapper: 'componentWrapper w-full',
  },
  'unidas-pelos-cachos-richtext-section': {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto cachosRichTxtMainContainer',
    componentWrapper: 'componentWrapper mx-auto flex',
  },
  'unidas-pelos-cachos-final-section': {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto unidas-pelos-cachos',
    componentWrapper: 'componentWrapper mx-auto unidasPelosFinalImgBanner',
  },
  headingSection: {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto headingSection',
    componentWrapper: 'componentWrapper md:flex justify-between mx-auto mt-4p mb-4p',
  },
  'prov-section-container': {
    section: 'md:flex mt-20 md:mt-60 mb-60',
    container: 'md:flex lg:w-container mx-auto section-default',
    componentWrapper: 'md:flex componentWrapper mx-auto px-20 md:px-0',
  },
  'provfirst-section-container': {
    section: 'mt-20 md:mt-60 mb-60',
    container: 'flex lg:w-container mx-auto section-default',
    componentWrapper: 'componentWrapper mx-auto px-20 md:px-0',
  },
  'prov-inner-sectioncontainer': {
    section: 'md:flex w-full bg-dullGrey my-auto',
    container: 'md:flex w-full mx-auto section-default px-30 py-150 md:py-40',
    componentWrapper: 'componentWrapper mx-auto px-20 md:px-0',
  },
  'prov-inner-sectioncontainerNew': {
    section: 'md:flex w-full my-auto',
    container: 'md:flex w-full mx-auto section-default',
    componentWrapper: 'px-20 md:px-0 componentWrapper mx-auto px-20 md:px-0',
  },
  'prov-image-sectioncontainerNew': {
    section: 'md:flex w-full md:w-4/12 my-auto provoverlapimage',
    container: 'md:flex w-full mx-auto section-default',
    componentWrapper: 'componentWrapper mx-auto px-20 md:px-0',
  },
  'prov-section-container-four': {
    section: 'hidden md:block md:flex mt-60 mb-60',
    container: 'hidden md:block md:flex lg:w-container mx-auto section-default',
    componentWrapper: 'hidden md:block md:flex componentWrapper mx-auto px-20 md:px-0',
  },
  'prov-section-container-four-mobile': {
    section: 'block md:hidden md:flex mt-60 mb-60',
    container: 'block md:hidden md:flex lg:w-container mx-auto section-default',
    componentWrapper: 'block md:hidden md:flex componentWrapper mx-auto px-20 md:px-0',
  },
  'prov-banner-section': {
    section: '',
    container: 'flex lg:w-container mx-auto section-default',
    componentWrapper: 'componentWrapper mx-auto',
  },
  stripe:
  {
    section: '',
    container: 'flex mx-auto relative stripe',
    componentWrapper: ' w-12/12 componentWrapper mx-auto',
  },

  longformtextstripe:
  {
    section: '',
    container: 'flex mx-auto longformtextstripe',
    componentWrapper: ' w-12/12 componentWrapper mx-auto',
  },

  "novada-banner": {
    section: '',
    container: 'flex mx-auto relative novada-banner',
    componentWrapper: ' w-12/12 componentWrapper mx-auto mb-30 md:mb-50 lg:mb-30',

  },

  tedamossection: {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto novada-conlas my-20 md:my-30 px-20 md:px:0',
    componentWrapper: 'md:flex componentWrapper mx-auto',
  },
  "novado-techno": {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto  my-30 px-20 md:px-0 lg:px-0 relative novado-tecno md:mt-45',
    componentWrapper: ' w-12/12 componentWrapper mx-auto',
  },
  "novada-mascar": {
    section: '',
    container: 'flex lg:w-innerContainer mx-auto novada-mascar',
    componentWrapper: ' w-12/12 componentWrapper mx-auto',
  },
  "video-size": {
    section: "",
    container: "flex lg:w-innerContainer mx-auto",
    componentWrapper: "componentWrapper mx-auto nuevascontainer",
  },
  "image-size": {
    section: "",
    container: "flex w-full mx-auto",
    componentWrapper: "componentWrapper mx-auto nuevascontainer mb-[-3px] imageCarouselSection",
  },
  'section-anita': {
    section: '',
    container: 'flex w-full mx-auto section-default',
    componentWrapper: 'componentWrapper mx-auto',
  },
  'section-vita': {
    section: 'vita-section-container-01',
    container: 'flex w-full mx-auto section-default',
    componentWrapper: 'componentWrapper mx-auto',
  },
  'vita-section-container-02': {
    section: 'vita-section-container-02',
    container: 'flex lg:w-innerContainer mx-auto pt-20 md:pt-60 pb-60 section-default',
    componentWrapper: 'componentWrapper mx-auto',
  },
  'vita-section-container-gold' : {
    section: 'vita-section-container-gold',
    container: 'flex lg:w-innerContainer mx-auto pt-20 md:pt-60 pb-60 section-default',
    componentWrapper: 'componentWrapper mx-auto abc',
  },
  'vita-section-container-03': {
    section: 'vita-section-container-03 md:flex mt-20 md:mt-60 mb-60',
    container: 'md:flex lg:w-container mx-auto section-default',
    componentWrapper: 'md:flex componentWrapper mx-auto px-20 md:px-0',
  },
  'vita-section-container-04': {
    section: 'vita-section-container-04',
    container: 'flex lg:w-innerContainer mx-auto mt-20 mb-60 section-default',
    componentWrapper: 'componentWrapper mx-auto',
  },
  'vita-section-container-05': {
    section: 'vita-section-container-05',
    container: 'flex lg:w-innerContainer mx-auto section-default',
    componentWrapper: 'componentWrapper mx-auto',
  },
  'vita-landing-ingredients-section': {
    section: 'vita-ingredients-section',
    container: 'viewAllButtonWrapper lg:w-innerContainer mx-auto px-20 mt-20 lg:mt-10 font-BebasNeueRegular text-18 leading-30 tracking-wider text-center',
    componentWrapper: 'componentWrapper mx-auto',
  },
  'vita-section-button': {
    section: 'vita-section-container-button',
    container: 'flex lg:w-innerContainer mx-auto mt-60 mb-30 md:mb-10 section-default',
    componentWrapper: 'componentWrapper mx-auto',
  },
  'MissMarvelBannerSection': {
    section: 'MissMarvelBannerSection',
    container: 'flex md:w-full lg:w-full mx-auto section-default',
    componentWrapper: 'componentWrapper mx-auto w-full',
  },
  'marvel-text-section-container' : {
    section: 'marvel-text-section-container',
    container: 'flex lg:w-innerContainer mx-auto pt-50 pb-50 sm:pt-35 sm:pb-35 section-default',
    componentWrapper: 'componentWrapper mx-auto',
  },
  'marvel-section-listing': {
    section: '',
    container: 'lg:w-container mx-auto md:pb-0 my-50 md:px-15',
    componentWrapper: 'marvel-section-componentWrapper',
  },
};
